import { PublishKind } from '../../models/publishKinds';
import DayView, { DisplayMode } from '../day/dayView';
import { DayDTO } from '../../DTO/DayDTO';
import { ObjectKind } from '../../models/objectKinds';
import ModuleView from '../moduleView';
import ModuleDTO from '../../DTO/ModuleDTO';
import { TrainingItemDTO } from '../../DTO/TrainingItemDTO';
import TrainingitemView from '../trainingitemView';
import { MaterialItemDTO } from '../../DTO/MaterialItemDTO';
import MaterialView from '../materialView';
import { X } from 'react-feather';
import mainservice from '../../../services/MainService';
import DayModuleDTO from '../../DTO/DayModuleDTO';
import { useEffect, useState } from 'react';
import { FilesUpload, SuccessItem } from '../FileManager/FileManager';
import { GenericDTO } from '../../DTO/GenericDTO';
import InputB from '../../../components/InputB/InputB';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, ButtonGroup, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditFieldsPrinter from '../../editFields/EditFieldsPrinter';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

enum Status {
  standard,
  single,
  chooseBulk,
  bulkDone,
  loading,
}

function GetHeadline(objecKind: ObjectKind) {
  switch(objecKind) {
    case ObjectKind.day:
      return 'Neuen Tag anlegen'
    case ObjectKind.materialItem:
      return 'Neues Asset anlegen'
    case ObjectKind.module:
      return 'Neue Sequenz anlegen'
  }
  return 'Neues Item anlegen'
}

/*
id
: 
778
key1
: 
"data"
key2
: 
"materialKind"
unique
: 
true
value1
: 
"digitalFlip"
value2
: 
"__EMPTY__"
*/

const possibleMaterialKinds = [
  {
    name: 'Flips',
    key: 'digitalFlip',
    props: [
      {
        "id": -1,
        "key1": "data",
        "key2": "length",
        "value1": "99,5",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "width",
        "value1": "65,5",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "productionHints",
        "value1": "LESSMARKpGREATERMARKRollenpapier SLASHMARK PlotterLESSMARKSLASHMARKpGREATERMARK",
        "value2": "__EMPTY__",
      }
    ],
  },
  {
    name: 'Handouts',
    key: 'digitalHandout',
    props: [
      {
        "id": -1,
        "key1": "data",
        "key2": "length",
        "value1": "29,7",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "width",
        "value1": "21,0",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "productionHints",
        "value1": "LESSMARKpGREATERMARKA4LESSMARKSLASHMARKpGREATERMARK",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "copiesPerPerson",
        "value1": "1",
        "value2": "__EMPTY__",
      }
    ],
  },
  {
    name: 'Plakate',
    key: 'digitalPoster',
    props: [
      {
        "id": -1,
        "key1": "data",
        "key2": "length",
        "value1": "59,4",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "width",
        "value1": "42,0",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "productionHints",
        "value1": "LESSMARKpGREATERMARKDinMINUSMARKAMINUSMARK2 Plakatkarton SLASHMARK QuelleDOUBLEPOINTMARK Vorne MINUSMARK Pinwand SLASHMARK Matt double weight SLASHMARK PlotterLESSMARKSLASHMARKpGREATERMARK",
        "value2": "__EMPTY__",
      }
    ],
  },
  {
    name: 'Pins',
    key: 'digitalPin',
    props: [
      {
        "id": -1,
        "key1": "data",
        "key2": "length",
        "value1": "135,0",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "width",
        "value1": "104,0",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "productionHints",
        "value1": "LESSMARKpGREATERMARKRollenpapier SLASHMARK PlotterLESSMARKSLASHMARKpGREATERMARK",
        "value2": "__EMPTY__",
      }
    ],
  },
  {
    name: 'Dateien',
    key: 'digitalFile',
    props: [

    ],
  },
  {
    name: 'Lernkarten',
    key: 'collectible',
    props: [
      {
        "id": -1,
        "key1": "data",
        "key2": "length",
        "value1": "10,5",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "width",
        "value1": "7,5",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "productionHints",
        "value1": "LESSMARKpGREATERMARKA7LESSMARKSLASHMARKpGREATERMARK",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "copiesPerPerson",
        "value1": "1",
        "value2": "__EMPTY__",
      },
    ],
  },
  {
    name: 'Moderationskarten',
    key: 'moderationCard',
    props: [
      {
        "id": -1,
        "key1": "data",
        "key2": "length",
        "value1": "14,8",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "width",
        "value1": "10,5",
        "value2": "__EMPTY__",
      },
      {
        "id": -1,
        "key1": "data",
        "key2": "productionHints",
        "value1": "LESSMARKpGREATERMARKA6LESSMARKSLASHMARKpGREATERMARK",
        "value2": "__EMPTY__",
      }
    ],
  }
]

export function EditItem(props: {
  close?: () => void,
  item: GenericDTO,
  objectKind: ObjectKind,
  broadcastKey?: string,
  rerenderRightSide?: () => void,
  setEditItem?: (module: ModuleDTO | DayModuleDTO) => void,
}) {
  const [status, setStatus] = useState(Status.standard)
  const [materialKind, setMaterialKind] = useState('digitalFlip')
  const [protocol, setProtocol] = useState('')
  const [item, setItem] = useState(props.item)
  const [presetSaver, setPresetSaver] = useState(new MaterialItemDTO({id: -1, localMode: true, props: possibleMaterialKinds.find(p => p.key === 'digitalFlip')?.props}))
  const closeButton = <div className='w3-container'>
    <Button
      className='floatRight modestButton'
      onClick={() => {
        // send update signal for all items with this id:
        mainservice.broadcast(`updateId-${item.id}`, {})
        if (props.close) {
          props.close();
        }
        setStatus(Status.standard)
      }}
    ><CloseIcon /></Button>
  </div>
  useEffect(() => {
    setItem(props.item)
    setStatus(Status.standard)
  }, [props.item, props.item.id, props.item.objectKind, props.item.publishKind])
  async function setName(rv: string) {
    await item.setName(rv)
    setStatus(Status.single)
 }

 if (status === Status.chooseBulk || status === Status.bulkDone) {
  return <>
    {closeButton}
    <h2 className='textCenter w3-margin-top'>Asset Bulk Upload</h2>
    <div className='justify-content-center textCenter'>
      <div>
        <p>
          Welche Informationen wollen wir für die Elemente festlegen?
        </p>
      </div>

      <ButtonGroup
        sx={{marginTop: '16px', marginBottom: '16px'}}
      >
        {
          possibleMaterialKinds.map((pmk, index) => {
            return <Button
              key={`${pmk.key}`}
              variant={pmk.key === materialKind ? 'contained' : 'outlined'}
              onClick={async () => {
                setStatus(Status.loading)
                setMaterialKind(pmk.key)
                const presetProps = pmk.props.map(p => p)
                setPresetSaver(new MaterialItemDTO({id: -1, localMode: true, props: presetProps}))
                setTimeout(() => {
                  setStatus(Status.chooseBulk)
                }, 100)
              }}
            >{pmk.name}</Button>
          })
        }
      </ButtonGroup>
      <Accordion
        sx={{marginBottom: '16px', marginTop: '16px', textAlign: 'left'}}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Voreinstellungen</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {/*
          <Button
            variant='outlined'
            sx={{marginLeft: '16px'}}
            onClick={async () => {
              console.log('test presets', presetSaver.props)
              
            }}
          >
            test
          </Button>    
          */}
          <Box sx={{marginTop: '16px', marginBottom: '16px'}}>
            <EditFieldsPrinter
              keyPrefix='bulk-upload-'
              fields={presetSaver.getEditFields().filter(field => field.key1 !== 'file' && field.key2 !== 'materialKind')}
              item={presetSaver}
            />
          </Box>
        
        </AccordionDetails>
      </Accordion>
      {
        status === Status.bulkDone &&
        <>
          <div className='justify-content-center textCenter'>
            Upload fertig
          </div>
          {protocol}
        </>
      }
      <Box>
        <FilesUpload
          saveSingleFile={async (item: SuccessItem) => {
            let file = item
            let material = new MaterialItemDTO({
              id: -1,
              name: file.name.replace(/\...?.?.?$/, '') || file.name,
              publishKind: PublishKind.isTemplate,
              objectKind: ObjectKind.materialItem,
            })
            await material.saveToServer()
            for (let i = 0, m = presetSaver.props.length; i < m; i++) {
              await material.addProp(presetSaver.props[i].key1, presetSaver.props[i].key2, presetSaver.props[i].value1, presetSaver.props[i].value2)
            }
            for (let i = 0, m = presetSaver.tags.length; i < m; i++) {
              await material.setTag(presetSaver.tags[i], false, 'tags')
            }
            const fileProp = await material.addProp('defaultfile', 'raw', '', '', true, file.id)
            await material.addProp('data', 'materialKind', materialKind)
            await material.addProp('filesInfo', 'defaultFile', `${fileProp.id}`)
          }}
          setNewFileInfos={async (items: SuccessItem[], fails: SuccessItem[]) => {
            const successMsg = items.length > 0 ? 'Erfolgreiche Uploads: ' + items.length : ''
            const failMsg = fails.length > 0 ? 'Fehlgeschlagene Uploads: ' + fails.length : ''
            setProtocol([successMsg, failMsg].filter(s => s).join(' - '))
            setStatus(Status.bulkDone)
          }}
        />
      </Box>
    </div>
  </>
  }
  if (item.id === -1) {
    return <>
      {closeButton}
      <h2 className='textCenter w3-margin-top'>{GetHeadline(item.objectKind)}</h2>
      
      <div className='flex justify-content-center textCenter'>
        <div className='w3-padding'>
          <div>
            Namen eingeben um einzelnes neues Element zu erstellen
          </div>
          <div className='w3-padding'>
            <InputB
              placeholder='Name für neues Element'
              value={item.name}
              returnVal={setName}
              autofocus
              delay={-1}
              sendButton={`Speichern`}
            />
          </div>
        </div>
        { props.objectKind === ObjectKind.materialItem &&
          <div className='w3-padding'>
            <div>
              Oder... 
            </div>
            <div>
              <button
                className='neutralButton centerBox'
                onClick={() => {
                  setStatus(Status.chooseBulk)
                }}
              >Bulk Daten hochladen</button>
            </div>
          </div>
        }
      </div>
    </>
  }
  return <>
    {closeButton}
    { props.objectKind === ObjectKind.materialItem &&
      <MaterialView
        materialItem={item as MaterialItemDTO}
        parentObjectKind={ObjectKind.daymodule}
        parentPublishKind={PublishKind.isTemplate}
        displayMode={DisplayMode.edit}
        close={() => {
          if (props.close) {
            props.close();
          }
        }}
        trash={async () => {
          await item.templateTrash();
          if (props.close) {
            props.close();
          }
        }} />}
    { props.objectKind === ObjectKind.trainingItem &&
      <TrainingitemView
        trainingitem={item as TrainingItemDTO}
        parentObjectKind={ObjectKind.daymodule}
        parentPublishKind={PublishKind.isTemplate}
        displayMode={DisplayMode.edit}
        close={() => {
          if (props.close) {
            props.close();
          }
        }}
        trash={async () => {
          await item.templateTrash();
          if (props.close) {
            props.close();
          }
        }} />}
    { (props.objectKind === ObjectKind.module || props.objectKind === ObjectKind.daymodule) &&
      <ModuleView
        module={new ModuleDTO(item)}
        displayMode={DisplayMode.edit}
        close={() => {
          if (props.close) {
            props.close();
          }
        }}
        parentObjectKind={ObjectKind.daymodule}
        parentPublishKind={PublishKind.isTemplate}
        templateTrash={async () => {
          await item.templateTrash();
          if (props.close) {
            props.close();
          }
        }}
        addItem={(position: number, item: ModuleDTO, t: 'time' | 'position' | 'template2seminar' | 'duration') => {
          mainservice.broadcast(props.broadcastKey || 'nokey', {
            position: position,
            item: item,
            type: t,
          })
        }}
      />
    }
    { props.objectKind === ObjectKind.day &&
      <DayView
        day={item as DayDTO}
        displayMode={DisplayMode.edit}
        parentObjectKind={ObjectKind.seminarday}
        parentPublishKind={PublishKind.isTemplate}
        setEditItem={props.setEditItem}
        close={() => {
          if (props.close) {
            props.close();
          }
        }}
        templateTrash={async () => {
          await item.templateTrash();
          if (props.close) {
            props.close();
          }
        }}
        rerenderRightSide={props.rerenderRightSide} />}
  </>
}
